import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, updated, children }) => (
  <main className="bg-velis-dark min-h-screen pt-28 pb-24">
    <div className="max-w-3xl mx-auto px-6">
      <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-8">
        <ArrowLeft size={16} /> Retour à l’accueil
      </Link>
      <h1 className="font-display font-extrabold text-white text-4xl mb-3">{title}</h1>
      {updated && <p className="text-white/40 text-sm mb-10">Dernière mise à jour : {updated}</p>}
      <div className="space-y-8 text-white/75 leading-relaxed">{children}</div>
    </div>
  </main>
);

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-display font-bold text-white text-xl mb-3">{heading}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
